import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconNoteAddOutline = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconNoteAddOutline"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M10.962 15.865v2.683a1.03 1.03 0 0 0 .307.761 1 1 0 0 0 .735.306 1.03 1.03 0 0 0 .743-.306 1.01 1.01 0 0 0 .317-.761v-2.683h2.708a1.03 1.03 0 0 0 .752-.313 1.02 1.02 0 0 0 .313-.75 1 1 0 0 0-.313-.74 1.05 1.05 0 0 0-.752-.3h-2.708v-2.74a.99.99 0 0 0-.316-.732 1.05 1.05 0 0 0-.754-.306.99.99 0 0 0-.73.306 1 1 0 0 0-.3.732v2.74H8.228a1 1 0 0 0-.73.308 1.02 1.02 0 0 0-.306.745 1.02 1.02 0 0 0 .305.745 1 1 0 0 0 .731.308zM4.452 24a2 2 0 0 1-1.464-.639 2.02 2.02 0 0 1-.638-1.467V2.106A2.02 2.02 0 0 1 2.988.639 2.01 2.01 0 0 1 4.453 0h9.419c.284-.001.565.058.825.174.25.11.48.265.673.46l5.645 5.625c.188.205.343.438.459.69.119.263.179.55.175.839v14.106a2.02 2.02 0 0 1-.638 1.467 2.01 2.01 0 0 1-1.464.639zM13.7 6.808v-4.7H4.453v19.788h15.093V7.877h-4.781a1.03 1.03 0 0 1-.76-.307 1.03 1.03 0 0 1-.306-.762" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconNoteAddOutline);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
